import { FC } from 'react';

export interface EllipsisHorizontalIconProps {
  width?: number;
  height?: number;
  className?: string;
  stroke?: string;
}

/**
 * Три точки по горизонтали (меню/опции).
 */
export const EllipsisHorizontalIcon: FC<EllipsisHorizontalIconProps> = ({
  width = 30,
  height = 30,
  className = '',
  stroke = 'white',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <path
      d="M21.25 15C21.25 15.6904 21.8096 16.25 22.5 16.25C23.1904 16.25 23.75 15.6904 23.75 15C23.75 14.3096 23.1904 13.75 22.5 13.75C21.8096 13.75 21.25 14.3096 21.25 15Z"
      stroke={stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.75 15C13.75 15.6904 14.3096 16.25 15 16.25C15.6904 16.25 16.25 15.6904 16.25 15C16.25 14.3096 15.6904 13.75 15 13.75C14.3096 13.75 13.75 14.3096 13.75 15Z"
      stroke={stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.25 15C6.25 15.6904 6.80964 16.25 7.5 16.25C8.19036 16.25 8.75 15.6904 8.75 15C8.75 14.3096 8.19036 13.75 7.5 13.75C6.80964 13.75 6.25 14.3096 6.25 15Z"
      stroke={stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
